import React from 'react';
import {UserDocModel} from "../models/responses/user.model";
import ProjectMembersModel from "../models/responses/project-members.model";

export default function (props: {user: UserDocModel | ProjectMembersModel, width: number, height: number}) {

    const {user, width, height} = props;

    const colorPalette = [
        '#e879f9', '#c084fc', '#f472b6', '#38bdf8', '#2dd4bf', '#f87171', '#fb923c', '#a3e635'
    ]

    return (
      <div>
      {user && user.photoURL ?
          <img src={user.photoURL} alt="user" className="user-image"
                style={{width: width, height: height}}
          />
          : <div className="user-image-div"
                 style={{backgroundColor: user?.userColour ? user?.userColour : '#0d71bb',
                     width: width,
                     height: height,
                     fontSize: `${width / 2}px`,
                 }}>
              {user && user.displayName ? user.displayName[0].toUpperCase() :
              user?.userEmail[0].toUpperCase()}</div>}
      </div>
  );

}
